import React from 'react';
import CurrencyInput from '../CurrencyInput';

function ReceitaModal({ show, onClose, onSubmit, form, handleChange, programas = [], acoes = [], contas = [], title = 'CADASTRO DE RECEITA' }) {
    const [contasFiltradas, setContasFiltradas] = React.useState([]);
    const isEditing = form._isEditing;
    React.useEffect(() => {
      if (!form.idPrograma) {
        setContasFiltradas([]);
        return;
      }
      const filtradas = contas.filter(c => String(c.idPrograma) === String(form.idPrograma));
      setContasFiltradas(filtradas);
      if (filtradas.length === 1 && form.idConta !== filtradas[0].numConta) {
        handleChange({ target: { name: 'idConta', value: filtradas[0].numConta } });
      }
    }, [form.idPrograma, contas]);
  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-cash-coin me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Programa *</label>
                  <select className="form-select form-select-sm" name="idPrograma" value={form.idPrograma} onChange={handleChange} required disabled={isEditing}>
                    <option value="">Selecione...</option>
                    {programas.map(p => <option key={p.id} value={p.id}>{p.descricao}</option>)}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Ação *</label>
                  <select className="form-select form-select-sm" name="idAcao" value={form.idAcao} onChange={handleChange} required>
                    <option value="">Selecione...</option>
                    {acoes.filter(a => !form.idPrograma || a.idPrograma === parseInt(form.idPrograma)).map(a => <option key={a.id} value={a.id}>{a.descricao}</option>)}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Conta *</label>
                  <select className="form-select form-select-sm" name="idConta" value={form.idConta} onChange={handleChange} required disabled={isEditing}>
                    <option value="">Selecione...</option>
                    {contasFiltradas.map(c => <option key={c.numConta} value={c.numConta}>{c.numConta}</option>)}
                  </select>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Destinação *</label>
                <input type="text" className="form-control" name="destinacao" value={form.destinacao} onChange={handleChange} required />
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Valor Custeio</label>
                  <CurrencyInput className="form-control" name="vlrC" value={form.vlrC} onChange={handleChange} />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Valor Capital</label>
                  <CurrencyInput className="form-control" name="vlrK" value={form.vlrK} onChange={handleChange} />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Data</label>
                  <input type="date" className="form-control" name="data" value={form.data} onChange={handleChange} />
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReceitaModal;
